import { render, staticRenderFns } from "./SubMenuBar.vue?vue&type=template&id=3c0414eb&scoped=true&"
import script from "./SubMenuBar.vue?vue&type=script&lang=js&"
export * from "./SubMenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0414eb",
  null
  
)

export default component.exports